import InitSplide from "./splide";

export default function tableOfContents() {
    const content = $('#main');
    const tableOfContentsUL = $('[data-table-of-contents-ul]');
    const tocSection = $('section.table_of_contents');
    if (!content.length || !tableOfContentsUL.length) {
        return;
    }

    const headings = content.find('h2');
    if (headings.length) {
        tocSection.removeClass('hide');
    }

    headings.each(function (i) {
        let text = $(this).text();
        const shortText = text.length > 30 ? text.slice(0, 30) + '...' : text;
        const id = $(this).attr('id') || text.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');
        $(this).attr('id', id);
        const link = $('<a>', {href: `#${id}`, text: `${i + 1}. ${shortText}`});
        tableOfContentsUL.append($('<li>', {class: 'splide__slide'}).append(link));
    });

    InitSplide();
}